import styled from 'styled-components';
import { ConfirmButton } from 'components/ui/Button';

export const StyledConfirmButton = styled(ConfirmButton)`
  margin-left: 16px;
`;

export const ErrorMessage = styled.div`
  color: red;
`;

export const StyledAddMasterReferenceConfirmation = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
